// extracted by mini-css-extract-plugin
module.exports = {"User":"_3Y_tI7Kx","Avatar":"_1bvwIcGN","userOptionsContainer":"_1V1OLOaS","adminOption":"_2wkZMGE8","signOutOption":"_3kc0G5wv","Option":"f3n09fzB","avatarContainer":"Exn17R2-","avatarContainerDark":"qRXB0sy1","userCaret":"_7Y-7GA3A","companyName":"_2H1hN2ST"};
    if(module.hot) {
      // 1746735821426
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  